import {ICommonComponentProps} from "../../definitions/common.definitions";
import {PageEntityT} from "../../models/pages/pages-provider";
import {useGet} from "../../transport/useGet";
import {ArticleEntityT} from "../../models/articles/articles-provider";
import {EndpointsEnum} from "../../constants/endpoints";
import {sanitizeContent} from "../../utils/html";
// import {Image} from "primereact/image";
import {InfoPageLayout} from "../info-page-layout/info-page-layout.component";
import {replaceTags} from '../../utils/string';
import {useRecords} from '../../models/records/records-provider';
import DocumentManager from '../document-manager/document-manager';
import React, {useEffect, useRef} from 'react';
import {Messages} from "primereact/messages";
import {Button} from 'primereact/button';
import {useSearchParams} from 'react-router-dom';

export type UniversalPagePropsT = ICommonComponentProps & {
  entity: PageEntityT;
}

const UniversalPage = (props: UniversalPagePropsT) => {
  const {
    entity,
  } = props;

  const {
    title,
    hasArticle,
    hasDocuments,
    categoryId,
    subCategoryId,
    articleId,
    disableCategory,
    disableSubCategory,
    disclaimer,
    disclaimerUrl,
  } = entity;

  const {
    mappedData,
  } = useRecords();

  const [searchParams] = useSearchParams();
  
  // Читаем параметры фильтрации из URL
  const urlCategoryId = searchParams.get('c');
  const urlSubCategoryId = searchParams.get('s');
  const urlYear = searchParams.get('y');
  
  // Определяем приоритет: URL параметры имеют приоритет над entity параметрами
  // Проверяем, что URL параметры являются валидными числами
  const finalCategoryId = urlCategoryId && !isNaN(parseInt(urlCategoryId, 10)) 
    ? parseInt(urlCategoryId, 10) 
    : categoryId;
  const finalSubCategoryId = urlSubCategoryId && !isNaN(parseInt(urlSubCategoryId, 10)) 
    ? parseInt(urlSubCategoryId, 10) 
    : subCategoryId;
  const finalYear = urlYear && !isNaN(parseInt(urlYear, 10)) 
    ? parseInt(urlYear, 10) 
    : undefined;

  const msgs = useRef<any>(null);

  useEffect(() => {
    if (msgs.current && disclaimer) {
      msgs.current.clear();
      msgs.current.show({
        id: '1',
        sticky: true,
        severity: 'info',
        summary: 'Уточнение',
        closable: false,
        content: (
          <div
            className={'flex align-items-center'}
          >
            {disclaimer}
            {
              disclaimerUrl && (
                <Button
                  className={'ml-3'}
                  label={'Перейти'}
                  size={'small'}
                  onClick={() => window.open(disclaimerUrl, '_blank', 'noopener,noreferrer')}
                />
              )
            }
          </div>
        ),
      });
    }
  }, [entity, msgs, disclaimer, disclaimerUrl]);

  const {
    data: article,
    isLoading: articleLoading,
  } = useGet<ArticleEntityT>({
    key: hasArticle ? [EndpointsEnum.ARTICLES, articleId].join('/') : null,
    auth: false,
  });

  return (
    <InfoPageLayout
      title={article?.title ?? title}
      progress={articleLoading}
    >
      {
        disclaimer && (
          <div className="flex my-3 min-w-full">
            <Messages ref={msgs}/>
          </div>
        )
      }
      {
        hasDocuments && (
          <DocumentManager
            initCategoryId={finalCategoryId}
            initSubCategoryId={finalSubCategoryId}
            disableCategory={disableCategory}
            disableSubCategory={disableSubCategory}
            year={finalYear}
          />
        )
      }
      {
        hasArticle && article?.content && (
          <span
            dangerouslySetInnerHTML={sanitizeContent(replaceTags(article.content ?? '', mappedData))}
          />
        )
      }
      {/*<div*/}
      {/*  className={'flex flex-column align-items-center'}*/}
      {/*>*/}
      {/*  <Image*/}
      {/*    src={'/images/145035.jpg'}*/}
      {/*    width={'100%'}*/}
      {/*  />*/}
      {/*</div>*/}
    </InfoPageLayout>
  );
}

export default UniversalPage;